import React,{useContext } from 'react'
import {Box,Typography} from '@mui/material';
import css from './login.module.css';
import styled from '@emotion/styled';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import {BsLockFill as LockIcon} from 'react-icons/bs';
//import { Button } from '../../../ui-components';
import Button from "../../../customs/Button";
import apiCall from '../../../utils/apiCall';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { useMutation } from '@tanstack/react-query';
import { Field, FormikProvider, FormikValues, useFormik } from 'formik';
import Input from "../../../customs/FormInput";
import { NotificationContext } from '../../../providers/notification';
import { useModal } from '../../../hooks/Context';

interface Payload {
  CurrentPassword: string;
  NewPassword: string;
  ConfirmPassword: string;
}

const NewPassword = () => {
  const { setShowModal } = useModal();
  const { showNotification } = useContext(NotificationContext);

  const userId = useSelector((state: RootState) => state?.user?.userId);

  const postChangePassword = async (data: Payload) => {
    return (await apiCall().post(`/Applicant/ChangePasswordAsync?applicantId=${userId}`, data))
  };

  const postChangePasswordMutation = useMutation(['post-change-password'], postChangePassword, { retry: 0 });

  const postChangePasswordHandler = async (values: FormikValues, resetForm: () => void) => {
    const payload: Payload = {
      CurrentPassword: values?.oldPassword,
      NewPassword: values?.newPassword,
      ConfirmPassword: values?.confirmPassword,
    };

    try {
      await postChangePasswordMutation.mutateAsync(payload, {
        onSuccess: () => {
          showNotification({
            type: 'success',
            message: 'Password has been successfully changed'
          })
          resetForm();
          setShowModal(false);
        }
      })
    } catch(error: any) {
      showNotification({
        type: 'error',
        message: error?.response?.data?.Message || error?.title,
      })
    }
  };

  const validationSchema = Yup.object().shape({
    oldPassword: Yup.string().required('required'),
    newPassword: Yup.string()
      .min(8,  'Password too short')
      .matches(/\d+/, { message:  'Password must include number' })
      .matches(/[a-z]+/, {message: 'Password must include an lowercase letter' })
      .matches(/[A-Z]+/, { message: 'Password must include a uppercase letter' })
      .matches(/[!@#$%^&*()-+_]+/, { message: 'Password must include special character' })
      .test(
        'Password has spaces',
        { spaces: 'Password has spaces'},
        value => !/\s+/.test(value as string)
      )
      .required('required')
      .notOneOf([Yup.ref('oldPassword'), ''], 'New password cannot be same as old password'),
    confirmPassword: Yup.string()
      .label('Confirm Password')
      .required().oneOf([Yup.ref('newPassword'), ''], 'Passwords must match'),
  });

  
const formik = useFormik<FormikValues>({
  initialValues: {
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  },
  onSubmit: (values, { resetForm }) => {
    postChangePasswordHandler(values, resetForm)
  },
  validationSchema,
});
 
  return (
    <Wrapper>
       <div>
        <span>
          <LockIcon/>
        </span>
        <span>
          Reset Password
        </span>

      </div>
      <FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
            <FormWrapper>
              <Field 
                name='oldPassword'
                type='password'
                as={Input}
                label='Old Password'
                placeholder='Old Password'
              />
              <Field 
                name='newPassword'
                type='password'
                as={Input}
                label='New Password'
                placeholder='New Password'
              />
              <Field 
                name='confirmPassword'
                type='password'
                as={Input}
                label='Confirm Password'
                placeholder='Confirm Password'
              />
            </FormWrapper>
            <ButtonWrapper>
              <ButtonContainer>
                <StyledButton text='Cancel'/>
                <StyledButton 
                  type="submit" 
                  text={postChangePasswordMutation.isLoading ? 'Submitting' : 'Submit'}
                  disabled={postChangePasswordMutation.isLoading}
                />
              </ButtonContainer>
            </ButtonWrapper>
        </form>
      </FormikProvider>

    </Wrapper>
  )
}

export default NewPassword;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 480px;
  & > div:first-of-type{
      padding:30px 20px;
      border-radius: 8px 8px 0 0;
      background-color:#20BB70;
      color:var(--white-color);
      display:flex;
      gap:30px;
      align-items: center;
  }
  & > div:first-of-type > span:first-of-type{
    display:flex;
    width:45px;
    height:45px;
    justify-content: center;
    align-items:center;
    background-color: #199056;
    font-size:25px;
    border-radius: 5px;
  }
  & > div:first-of-type > span:nth-of-type(2){
    font-size:20px;
    font-weight:bold;
  }
  & > form:nth-of-type(1){
    padding:20px;
    background-color:var(--white-color);
    display:flex;
    flex-direction:column;
    gap:30px;
    min-height:200px;
    width:100%;
  }
 
  & > form:nth-of-type(1) > div{
    display:flex;
    gap:20px;
    justify-content:flex-end;
    align-items:center;
  }
  & > form:nth-of-type(1) > div > span{
    cursor:pointer;
  }
`;

const FormWrappers = styled.form`
  display:flex;
  flex-direction:column;
  gap:10px;
  background-color:var(--white-color);
  padding:20px;
  & > div{
    display:flex;
    align-items:center;
    justify-content:flex-end;
    gap:20px;
  }
  & > div > a{
    text-decoration:none;
    color:gray;
  }

`
const StyledLabel = styled.label`
  display:flex;
  flex-direction:column;
  gap:5px;;
  & > *{
    display:inline-block;
    width:100%;
  }
`;

const StyledInput = styled.input`
  border:1px solid #E1E1E1;
  padding:12px;
  border-radius:4px;
  font-size:16px;

`
const StyledSpan = styled.span`
  color:red;
`;

const FormWrapper = styled('div')`
  margin-block-start: 20px;
  margin-inline: 40px;
  display: flex;
  flex-direction: column;
`

const ButtonWrapper = styled('div')`
    display: flex;
    justify-content: flex-end;
    //margin-block: 2.5rem;
    padding-inline: 40px;
`

const ButtonContainer = styled('div')`
    display: flex;
    gap: 2rem;
`

const StyledButton = styled(Button)`
    padding-block: 1rem;
    padding-inline: 2rem;
`
